import React, { Component } from 'react';
import { object, bool, array } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import SmallGigCardCarousel from '@fiverr-private/gig_listings/src/entries/SmallGigCardCarousel';
import GigCardCarouselHOC from '../../shared/GigCardCarouselHOC';
import localStorage from '../localStorage';
import {
    RECENTLY_VIEWED_PAGE_PATH,
    sliderBreakpoints,
    sliderBaseNum
} from './config';

import './style.scss';

class RecentlyViewedGigs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isDeleted: false,
            isTotallyDeleted: false
        };

        this.onClearAllClick = this.onClearAllClick.bind(this);
        this.clearRecentlyViewedGig = this.clearRecentlyViewedGig.bind(this);
    }

    onClearAllClick() {
        const { pathfinderWrapper, logger } = this.context;
        const { isLoggedIn } = this.props;

        if (isLoggedIn) {
            const url = pathfinderWrapper.pathfinder('clear_recently_viewed_gigs');

            gofor(url, {
                method: 'DELETE'
            }).catch((error) => {
                logger.error(error);
            });
        } else {
            localStorage.clearAllGigs();
        }

        this.hideComponent();
    }

    hideComponent() {
        /*
            we set isDeleted first which triggers a 2 second fade out
            then we set isTotallyDeleted to remove the entire element
        */

        this.setState({
            isDeleted: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    isTotallyDeleted: true
                });
            }, 2000);
        });
    }

    clearRecentlyViewedGig(gigId) {
        localStorage.clearGig(gigId);
        if (!localStorage.getGigIds(gigId).length) {
            this.hideComponent();
        }
    }

    render() {
        const {
            isLoggedIn,
            showTranslatedUGC,
            gigs,
            isLoading,
            contextEnrichment
        } = this.props;

        const {
            isDeleted, // this only applies if the user clears all the gigs
            isTotallyDeleted // this only applies if the user clears all the gigs
        } = this.state;

        if (isTotallyDeleted) {
            return null;
        }

        const boxClasses = classNames('gigs-recently-viewed', { 'deleted': isDeleted });

        // Currently logged in Api is implemented as default in gig cards package
        const onCarouselItemClear = isLoggedIn ? undefined : this.clearRecentlyViewedGig;

        return (
            <div className={boxClasses}>
                <h2 className="section-title">
                    <I18n k={'gig_page_perseus.recommended_gigs.your_browsing_history.title'}/>
                    {!isDeleted &&
                        <small>
                            <button onClick={this.onClearAllClick}>
                                <I18n k={'gig_page_perseus.general.clear_all'}/>
                            </button>
                            {isLoggedIn &&
                            <a href={RECENTLY_VIEWED_PAGE_PATH} className="see-all">
                                <I18n k={'gig_page_perseus.general.see_all'}/>
                            </a>
                            }
                        </small>
                    }
                </h2>
                <SmallGigCardCarousel gigs={gigs}
                    isLoading={isLoading}
                    sliderBaseNum={sliderBaseNum}
                    showTranslatedUGC={showTranslatedUGC}
                    sliderBreakpoints={sliderBreakpoints}
                    onClearGig={onCarouselItemClear}
                    lazyLoad={true}
                    {...contextEnrichment}/>
            </div>
        );
    }
}

RecentlyViewedGigs.propTypes = {
    isLoggedIn: bool,
    showTranslatedUGC: bool,
    gigs: array,
    isLoading: bool,
    contextEnrichment: object
};

RecentlyViewedGigs.defaultProps = {
    showTranslatedUGC: false,
    gigs: [],
    isLoading: true,
    contextEnrichment: {}
};

RecentlyViewedGigs.contextTypes = {
    logger: object,
    requestContext: object,
    general: object,
    currencyConverter: object,
    pathfinderWrapper: object
};

export { RecentlyViewedGigs };
export default GigCardCarouselHOC(RecentlyViewedGigs);
